import React from "react"
import tw, { css, styled } from "twin.macro"
import { RESPONSIVE_HEIGHT } from "../utils/constants"


const NextPageContainer = styled.div`
  display: none;
  @media (min-height: ${RESPONSIVE_HEIGHT}px) {
    display: block;
  };
  ${tw`absolute bottom-0 mb-16`}
`

export default NextPageContainer
